import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from 'semantic-ui-react';
import InstagramDemographicsCountriesTable from
  'dyzio-shared-components/lib/components/instagram-demographics-countries-table';
import DemographicsLocationTable from
  'dyzio-shared-components/lib/components/demographics-location-table';

const TAB_STYLES = {
  marginBottom: 4,
};
const MODAL_LINK_STYLE = {
  cursor: 'pointer',
};

const getPanes = props => {
  const { audienceCities, onFullCountryClick, onFullCityClick } = props;
  const panes = [
    {
      menuItem: { content: 'Fans by Country', key: 'country', icon: 'globe' },
      render: () => <Tab.Pane>
        <InstagramDemographicsCountriesTable {...props} />
        <a style={MODAL_LINK_STYLE} onClick={onFullCountryClick}>
            View full engagement data
        </a>
      </Tab.Pane>,
    },
    {
      menuItem: { content: 'Fans by City', key: 'last12posts', icon: 'building outline' },
      render: () => <Tab.Pane>
        <DemographicsLocationTable
          data={audienceCities.data}
          metric="absolute"
          metricLabel="Followers"
          itemLabel="City"
        />
        <a style={MODAL_LINK_STYLE} onClick={onFullCityClick}>
            View full engagement data
        </a>
      </Tab.Pane>,
    },
  ];
  return panes;
};

const InstagramTabs = props => {
  const { audienceCities } = props;
  if (audienceCities) {
    return <Tab style={TAB_STYLES} panes={getPanes(props)} />;
  }
  return (
    <div>
      <h5>Fans by Country</h5>
      <InstagramDemographicsCountriesTable {...props} />
    </div>
  );
};

InstagramTabs.propTypes = {
  audienceCities: PropTypes.Object,
};
InstagramTabs.defaultProps = {
  audienceCities: undefined,
};

export default InstagramTabs;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-profile-data-large/location-tabs.js
 **/